import { render } from "./VideoView.vue?vue&type=template&id=c818899c&scoped=true"
import script from "./VideoView.vue?vue&type=script&lang=js"
export * from "./VideoView.vue?vue&type=script&lang=js"

import "./VideoView.vue?vue&type=style&index=0&id=c818899c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c818899c"]])

export default __exports__